import { Button, Paragraph } from 'common-components';
import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router';
import styled from '@emotion/styled';
import { useAppTranslation } from '@hooks';

const ErrorPage = () => {
  const navigate = useNavigate();
  const error = useRouteError();
  const { translate } = useAppTranslation();

  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = translate('errorPage.unknownError');
  }

  const ErrorPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `;

  return (
    <ErrorPageWrapper>
      <Paragraph>{errorMessage}</Paragraph>
      <Paragraph>{translate('errorPage.notFound')}</Paragraph>
      <Button onClick={() => navigate(-1)}>{translate('common.buttons.goBack')}</Button>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
